var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 8.296,
    viewBox: "0 0 14 8.296",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "down-arrow",
    d: "M20.361,9.265a1.328,1.328,0,0,0-1.873,0l-4.768,4.7-4.7-4.7a1.329,1.329,0,1,0-1.873,1.886l5.631,5.631a1.328,1.328,0,0,0,1.886,0l5.7-5.631a1.328,1.328,0,0,0,0-1.886Z",
    transform: "translate(-6.754 -8.879)",
    fill: "#474b4f",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/downArrow.25994db7b8ef8d7f1831168596a8132a.svg";
export { ForwardRef as ReactComponent };